import { Button } from 'components'
// import Link from 'next/link'
import React from 'react'

// import { useCollegeUser, useLoginState } from 'state'
import { tx } from '@twind/core'

// import { stepNameToStepNumber } from '../data/college.data'

const ApplyNowButton = ({
  variant = 'dark'
}: {
  variant?: 'dark' | 'white'
}) => {
  // const { user, isLoggedIn } = useLoginState()
  // const { collegeUser } = useCollegeUser()

  return (
    // <Link
    //   className={'cursor-pointer'}
    //   href={
    //     !user && !isLoggedIn
    //       ? '/school/login'
    //       : collegeUser && stepNameToStepNumber[collegeUser.state || ''] > 0
    //       ? '/school/register'
    //       : '/school/dashboard'
    //   }>
    //   <Button
    //     className={tx(
    //       variant === 'dark'
    //         ? 'bg-[#3C3C78] hover:bg-[#5A5AB4] text-white'
    //         : 'bg-white hover:bg-violet-50 text-[#3C3C78]',
    //       'min-w-fit'
    //     )}>
    //     {!user && !isLoggedIn
    //       ? 'Apply Now'
    //       : collegeUser && stepNameToStepNumber[collegeUser.state || ''] > 0
    //       ? 'Resume Application'
    //       : 'Apply Now'}
    //   </Button>
    // </Link>
    <Button
      disabled
      className={tx(
        variant === 'dark'
          ? 'bg-[#3C3C78] hover:bg-[#5A5AB4] text-white'
          : 'bg-white hover:bg-violet-50 text-[#3C3C78]',
        'min-w-fit'
      )}>
      Application Closed
    </Button>
  )
}

export default ApplyNowButton
